import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'cmms-simple-input',
	imports: [MatInputModule, ReactiveFormsModule],
	templateUrl: './cmms-simple-input.component.html',
	styleUrls: ['./cmms-simple-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmmsSimpleInputComponent implements OnInit {
	@Input() set value(value: string) {
		this.formControl.patchValue(value);
	}
	@Input() label: string = '';
	@Input() placeholder: string = '';

	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() valueChanged = new EventEmitter<string>();

	formControl = new FormControl('');

	ngOnInit() {
		this.controlReady.emit(this.formControl);
	}

	emitChanges() {
		if (this.formControl.valid) {
			this.valueChanged.emit(this.formControl.value);
		}
	}

	submitKeydown(event: KeyboardEvent) {
		event.preventDefault();
		this.formControl.markAsTouched();
		this.emitChanges();
	}
}
